import { useTranslation } from 'next-i18next'

import {
  Column,
  ColumnItem,
  ColumnLink,
  ColumnList,
  ColumnTitle,
  LinksContainer,
} from '@/components/shared/global-footer/footer-links/styled'
import { ToggleLocale } from '@/components/shared/toggle-locale'
import { FOOTER_LINKS } from '@/constants/footerLinks'

export const FooterLinks = () => {
  const { t } = useTranslation(['global_footer', 'common', 'routes'])

  const FOOTER_COLUMNS = FOOTER_LINKS(t)

  return (
    <LinksContainer>
      {FOOTER_COLUMNS.map((column) => (
        <Column key={`links-${column.title}`}>
          <ColumnTitle>{column.title}</ColumnTitle>

          <ColumnList>
            {column.links.map((link) => (
              <ColumnItem key={`${column.title}-${link.label}`}>
                {link.type === 'languageToggle' ? (
                  <ToggleLocale>
                    <ColumnLink>{link.label}</ColumnLink>
                  </ToggleLocale>
                ) : (
                  <ColumnLink href={link.href}>{link.label}</ColumnLink>
                )}
              </ColumnItem>
            ))}
          </ColumnList>
        </Column>
      ))}
    </LinksContainer>
  )
}
